@if (emeterChannels().length === 0) {
  <p class="m-0 text-sm text-text-secondary">
    {{ 'devices.pvForecast.dialog.noEmeter' | translate }}
  </p>
} @else {
  <form [formGroup]="form()" class="pv-form flex flex-col gap-5">
    <xemex-select-field
      [label]="'devices.pvForecast.dialog.emeter' | translate"
      [required]="true"
      [invalid]="isInvalid(form().controls.deviceIndex)"
      [errorText]="
        'error.required' | translate: { field: ('devices.pvForecast.dialog.emeter' | translate) }
      "
    >
      <mat-select
        formControlName="deviceIndex"
        panelClass="pv-forecast-form__select-panel"
        [hideSingleSelectionIndicator]="true"
        [placeholder]="'devices.pvForecast.dialog.emeterPlaceholder' | translate"
      >
        @for (channel of emeterChannels(); track channel.channelNumber) {
          <mat-option [value]="channel.channelNumber">
            @if (channel.isDeviceMeter) {
              {{ 'devices.pvForecast.dialog.deviceEmeter' | translate }}
            } @else {
              {{
                'devices.pvForecast.dialog.emeterOption'
                  | translate: { index: channel.channelNumber }
              }}
              @if (channel.description) {
                — {{ channel.description }}
              }
            }
          </mat-option>
        }
      </mat-select>
    </xemex-select-field>

    <div class="flex flex-col gap-4">
      <span class="text-sm font-semibold">
        {{
          (pvArrays.length > 1
            ? 'devices.pvForecast.dialog.arraysLabel'
            : 'devices.pvForecast.dialog.arrayLabel'
          ) | translate
        }}
      </span>

      @for (group of pvArrays; track $index) {
        @if (pvArrays.length > 1) {
          <div class="rounded-lg border border-border-default p-4">
            <div class="mb-3 flex items-center justify-between">
              <span class="text-sm font-medium text-text-default">
                {{ 'devices.pvForecast.dialog.arrayTitle' | translate: { number: $index + 1 } }}
              </span>
              <xemex-text-button
                type="button"
                intent="destructive"
                icon="delete"
                (click)="removeArray($index)"
              >
                {{ 'general.btnDelete' | translate }}
              </xemex-text-button>
            </div>
            <ng-container *ngTemplateOutlet="arrayFields; context: { $implicit: group }" />
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="arrayFields; context: { $implicit: group }" />
        }
      }

      <div>
        <xemex-text-button type="button" intent="primary" icon="add" (click)="addArray()">
          {{ 'devices.pvForecast.dialog.addArray' | translate }}
        </xemex-text-button>
      </div>
    </div>
  </form>
}

<ng-template #arrayFields let-group>
  <div class="pv-form__array" [formGroup]="group">
    <xemex-text-field
      class="pv-form__kwp"
      formControlName="kwp"
      [type]="'number'"
      [inputMode]="'decimal'"
      [label]="'devices.pvForecast.dialog.peakPower' | translate"
      [placeholder]="'4'"
      [required]="true"
      [invalid]="isInvalid(group.controls.kwp)"
      [errorText]="'devices.pvForecast.dialog.numberError' | translate"
    />

    <div class="flex flex-col gap-3">
      <xemex-select-field
        [label]="'devices.pvForecast.dialog.azimuth' | translate"
        [required]="true"
        [invalid]="isInvalid(group.controls.azimuthPreset)"
        [errorText]="
          'error.required' | translate: { field: ('devices.pvForecast.dialog.azimuth' | translate) }
        "
      >
        <mat-select
          formControlName="azimuthPreset"
          panelClass="pv-forecast-form__select-panel pv-forecast-form__preset-panel"
          [hideSingleSelectionIndicator]="true"
          [panelWidth]="null"
          [placeholder]="'devices.pvForecast.dialog.presetPlaceholder' | translate"
        >
          @for (preset of azimuthPresets; track preset.key) {
            <mat-option [value]="preset.key">{{ preset.labelKey | translate }}</mat-option>
          }
        </mat-select>
      </xemex-select-field>
      @if (group.controls.azimuthPreset.value === exact) {
        <xemex-text-field
          formControlName="azimuth"
          [type]="'number'"
          [inputMode]="'decimal'"
          [label]="'devices.pvForecast.dialog.azimuthExact' | translate"
          [placeholder]="'180'"
          [required]="true"
          [invalid]="isInvalid(group.controls.azimuth)"
          [errorText]="'devices.pvForecast.dialog.numberError' | translate"
        />
      }
      <span class="pv-form__hint">{{ 'devices.pvForecast.dialog.azimuthHint' | translate }}</span>
    </div>

    <div class="flex flex-col gap-3">
      <xemex-select-field
        [label]="'devices.pvForecast.dialog.tilt' | translate"
        [required]="true"
        [invalid]="isInvalid(group.controls.tiltPreset)"
        [errorText]="
          'error.required' | translate: { field: ('devices.pvForecast.dialog.tilt' | translate) }
        "
      >
        <mat-select
          formControlName="tiltPreset"
          panelClass="pv-forecast-form__select-panel pv-forecast-form__preset-panel"
          [hideSingleSelectionIndicator]="true"
          [panelWidth]="null"
          [placeholder]="'devices.pvForecast.dialog.presetPlaceholder' | translate"
        >
          @for (preset of tiltPresets; track preset.key) {
            <mat-option [value]="preset.key">{{ preset.labelKey | translate }}</mat-option>
          }
        </mat-select>
      </xemex-select-field>
      @if (group.controls.tiltPreset.value === exact) {
        <xemex-text-field
          formControlName="tilt"
          [type]="'number'"
          [inputMode]="'decimal'"
          [label]="'devices.pvForecast.dialog.tiltExact' | translate"
          [placeholder]="'35'"
          [required]="true"
          [invalid]="isInvalid(group.controls.tilt)"
          [errorText]="'devices.pvForecast.dialog.numberError' | translate"
        />
      }
      <span class="pv-form__hint">{{ 'devices.pvForecast.dialog.tiltHint' | translate }}</span>
    </div>
  </div>
</ng-template>
